/**
 * API Configuration
 * Centralized configuration for API endpoints and settings
 */

// Determine API base URL based on environment
const getApiBaseUrl = () => {
  // For production/deployment, use the current domain
  if (process.env.NODE_ENV === 'production' || window.location.hostname !== 'localhost') {
    // Use learnalllevels.com backend
    return 'https://learnalllevels.com/api';
  }
  
  // For local development with XAMPP
  return 'http://localhost/edulearn-backend';
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  TIMEOUT: 10000, // 10 seconds timeout
  RETRY_ATTEMPTS: 2,
  
  ENDPOINTS: {
    TOPICS: '/api/topics',
    BOOKMARKS: '/api/bookmarks',
    QUIZ: '/api/quiz',
    PROGRESS: '/api/progress',
    ADMIN: '/api/admin'
  },
  
  // Error messages
  ERROR_MESSAGES: {
    NETWORK_ERROR: 'Network error. Using offline mode.',
    TIMEOUT_ERROR: 'Request timeout. Using offline mode.',
    SERVER_ERROR: 'Server error. Using offline mode.',
    PARSE_ERROR: 'Invalid server response. Using offline mode.'
  }
};

// Alternative API URLs for different environments
export const API_URLS = {
  LOCAL_XAMPP: 'http://localhost/edulearn-backend',
  LOCAL_XAMPP_ALT: 'http://127.0.0.1/edulearn-backend',
  PRODUCTION: 'https://learnalllevels.com/api', // Updated for learnalllevels.com
};

export default API_CONFIG;